import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Helmet from 'react-helmet';
import { usePage } from '@inertiajs/inertia-react';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink } from '@inertiajs/inertia-react';
import SiteLayout from '../../Shared/SiteLayout';
import SelectInput from '../../Shared/SelectInput';
import LoadingButton from '../../Shared/LoadingButton';
import TextInput from '../../Shared/TextInput';
import Icon from '../../Shared/Icon';
import classNames from 'classnames';

function Show() {
     const { auth, app, errors, data } = usePage().props;

     const iconClasses = classNames('w-4 h-4 ml-2', {
          'text-white fill-current': false,
          'text-gray-500 hover:text-white fill-current': true
     });

     return (
          <React.Fragment key="cahier-exo">
               <Helmet>
                    <title>{app.name}</title>
               </Helmet>
               <section className="w-full bg-white pt-10 pb-10">
                    <div className="container mx-auto md:p-3">
                         <div className="max-w-7xl mt-10">
                              <h1 className="font-bold text-center text-4xl uppercase bg-clip-text text-emerald-800">Cahier d'Exercices</h1>
                              <h2 className="font-semibold text-center text-2xl text-gray-700 text-md">{data.book.name}</h2>
                              <p className="text-sm text-center text-gray-500 italic">{data.book.description}</p>
                         </div>
                         <div className="flex mt-5 w-full md:flex">
                              <div className="w-1/4"></div>
                              <div className="w-1/4 border-r border-r-gray-200">
                                   {data.user && (<div className="w-full p-2">
                                        <div className="w-full text-md text-gray-600">Élève : <span className="font-semibold">{data.user.name}</span></div>
                                        {data.user.sex && (<div className="w-full text-md text-gray-600">Sexe : <span className="font-semibold">{data.user.sex}</span></div>)}
                                        <div className="w-full text-md text-gray-600">École : <span className="font-semibold">{data.user.ecole}</span></div>
                                        <div className="w-full text-md text-gray-600">Ville : <span className="font-semibold">{data.user.commune}</span></div>
                                        {data.user.email && (<div className="w-full text-md text-gray-600">E-Mail : <span className="font-semibold">{data.user.email}</span></div>)}
                                        {data.user.phone && (<div className="w-full text-md text-gray-600">Téléphone : <span className="font-semibold">{data.user.phone}</span></div>)}
                                   </div>)}
                              </div>
                              <div className="w-1/4">
                                   {data.book && (<div className="w-full p-2">
                                        {data.book.file && (<ul className="list-inside">
                                             {data.book.file.map((file, i) => {
                                                  return <li key={`f${i}`}>
                                                       <a className="flex items-center hover:underline" href={route('notebook.download.book', file.id)}>
                                                            {file.descripition} <Icon name="download" className={iconClasses} />
                                                       </a>
                                                  </li>
                                             })}
                                        </ul>)}
                                   </div>)}
                              </div>
                              <div className="w-1/4"></div>
                         </div>
                    </div>
               </section>
          </React.Fragment>
     );
}

Show.layout = page => <SiteLayout children={page} header={'Cahier Exercice'} />;

export default Show;
